module.exports = __webpack_public_path__ + "img/logo.ec58849c.jpg";